import { Title } from 'components/Title';
import { WhiteBlock } from 'components/WhiteBlock';
import styles from './BeneficiarBlock.module.scss';
import { Button } from 'ui/Button';
import {
  useGetBeneficiaryDocumentsDataMutation,
  useGetResendBeneficiaryDocumentsDataMutation,
} from 'redux/Api/ordersApi/ordersApi';
import { useState } from 'react';
import { DocumentsDataTypes, ModalDocumentsBeneficiar } from './ModalDocumentsBeneficiar';
import { ResendBeneficiaryDocumentsModal } from './ResendBeneficiaryDocumentsModal';
import { dateForOrderDetails } from 'utils/date';

interface BeneficiarBlockTypes {
  data?: {
    id: number;
    is_active: boolean;
    is_added_to_ms: boolean;
    is_oferta_uploaded: boolean;
    tochka_uuid: string;
    created_at: string;
    updated_at: string;
    documents_sent_at: string | null;
  };
}

export const BeneficiarBlock = ({ data }: BeneficiarBlockTypes) => {
  const [isShowDocumentsBeneficiarModal, setIsShowDocumentsBeneficiarModal] =
    useState(false);
  const [documentsBeneficiaryDocumentsData, setdocumentsBeneficiaryDocumentsData] =
    useState<DocumentsDataTypes | null>(null);
  const [resendBeneficiaryDocumentsModal, setResendBeneficiaryDocumentsModal] =
    useState<boolean>(false);
  const [textNotification, setTextNotification] = useState<string>('');

  const [getBeneficiaryDocumentsData] = useGetBeneficiaryDocumentsDataMutation();
  const [getResendBeneficiaryDocumentsData] =
    useGetResendBeneficiaryDocumentsDataMutation();

  const handleGetBeneficiaryDocumentsData = async () => {
    setdocumentsBeneficiaryDocumentsData(null);
    try {
      const response = await getBeneficiaryDocumentsData({
        beneficiary_id: String(data?.tochka_uuid),
      }).unwrap();
      setdocumentsBeneficiaryDocumentsData(response);
      setIsShowDocumentsBeneficiarModal(true);
    } catch (error) {
      console.error('Ошибка получения данных:', error);
    }
  };

  const handleSendDocuments = async () => {
    setTextNotification('');
    try {
      const response = await getResendBeneficiaryDocumentsData({
        beneficiary_id: String(data?.tochka_uuid),
      }).unwrap();

      if (response.message) {
        setTextNotification(response.message);
        setResendBeneficiaryDocumentsModal(true);
      }
    } catch (error) {
      console.error('Ошибка при отправке документов на валидацию:', error);
      setTextNotification('Ошибка при отправке документов на валидацию');
      setResendBeneficiaryDocumentsModal(true);
    }
  };

  return (
    <>
      <WhiteBlock style={{ paddingRight: '4px' }}>
        <div className={styles.container_title}>
          <Title title='Бенефициар' />
        </div>
        {data ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '10px',
            }}>
            <div className={styles.root}>
              <div className={styles.root_item}>
                <p>Активен</p> <span>{data?.is_active ? 'Да' : 'Нет'}</span>
              </div>
              <div className={styles.root_item}>
                <p>Добавлен в мастер систему</p>
                <span>{data?.is_added_to_ms ? 'Да' : 'Нет'}</span>
              </div>
              <div className={styles.root_item}>
                <p>Оферта загружена</p>
                <span>{data?.is_oferta_uploaded ? 'Да' : 'Нет'}</span>
              </div>
              <div className={styles.root_item}>
                <p>Дата создания</p>
                <span>
                  {data?.created_at ? dateForOrderDetails(data?.created_at) : ''}
                </span>
              </div>
              <div className={styles.root_item}>
                <p>Дата обновления</p>
                <span>
                  {data?.updated_at ? dateForOrderDetails(data?.updated_at) : ''}
                </span>
              </div>
              <div className={styles.root_item}>
                <p>Дата отправки документов</p>
                <span>
                  {data?.documents_sent_at
                    ? dateForOrderDetails(data?.documents_sent_at)
                    : '-'}
                </span>
              </div>
            </div>
            <div>
              {data && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    paddingRight: '24px',
                  }}>
                  <Button
                    theme='filed'
                    size='S'
                    onClick={handleGetBeneficiaryDocumentsData}>
                    Показать статус документов
                  </Button>
                  <Button theme='filed' size='S' onClick={handleSendDocuments}>
                    Отправить документы на валидацию
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div style={{ paddingRight: '24px' }}>{'Нет бенефициара'}</div>
        )}
      </WhiteBlock>
      {isShowDocumentsBeneficiarModal && (
        <ModalDocumentsBeneficiar
          isShowDocumentsBeneficiarModal={isShowDocumentsBeneficiarModal}
          setIsShowDocumentsBeneficiarModal={setIsShowDocumentsBeneficiarModal}
          documentsData={documentsBeneficiaryDocumentsData}
        />
      )}
      {resendBeneficiaryDocumentsModal && (
        <ResendBeneficiaryDocumentsModal
          textNotification={textNotification}
          setResendBeneficiaryDocumentsModal={setResendBeneficiaryDocumentsModal}
          resendBeneficiaryDocumentsModal={resendBeneficiaryDocumentsModal}
        />
      )}
    </>
  );
};
